import React from "react";

const Link = props => (
  <svg viewBox="0 0 27 28" {...props}>
    <path
      d="M25.567 8.193l-6.558 6.587c-.52.52-1.358.52-1.878 0l-.953-.953.924-.925.462.462c.26.26.665.26.925 0l5.633-5.633a.645.645 0 000-.924l-3.726-3.785a.645.645 0 00-.925 0L13.81 8.656a.645.645 0 000 .924l.462.462-.924.925-.925-.896a1.325 1.325 0 010-1.878l6.587-6.586c.52-.52 1.358-.52 1.878 0l4.709 4.709a1.3 1.3 0 01-.03 1.877zM7.713 19.49a.645.645 0 010-.925l9.418-9.417c.26-.26.665-.26.925 0s.26.664 0 .924L8.638 19.49a.645.645 0 01-.925 0zm.925-4.709a.645.645 0 00-.925 0l-5.662 5.633a.645.645 0 000 .925l3.785 3.784c.26.26.664.26.924 0l5.662-5.633a.645.645 0 000-.925l-.462-.462.924-.924.925.924c.52.52.52 1.358 0 1.878l-6.587 6.558c-.52.52-1.358.52-1.878 0l-4.68-4.71a1.325 1.325 0 010-1.877l6.558-6.587c.52-.52 1.358-.52 1.878 0l.924.925-.924.924-.462-.433z"
      fill="currentColor"
      fillRule="nonzero"
      stroke="currentColor"
      strokeWidth={0.52}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Link;
